<script>
  export default {
    name: 'list-show-button',
    props: ['routeName', 'item']
  }
</script>

<template>
    <router-link :to="{ name: routeName, params: { id: item.id } }"
                 class="el-button el-button--default"
                 title="Visualizar Dados">
        <i class="fa fa-eye"></i>
    </router-link>
</template>



// WEBPACK FOOTER //
// ShowButton.vue?15f28810